import React from 'react'
import ChevronIcon from '../elements/icons/ChevronIcon'
import { NavLink, useLocation } from 'react-router-dom'
import useHorizontalScroller from '../../hooks/useHorizontalScroller'

const AdministrationLayout = ({children}) => {
    const location = useLocation();
    const currentRoute = location.pathname;
    const {
        scrollContainerRef,
        canScrollLeft,
        canScrollRight,
        scrollByDirection,
    } = useHorizontalScroller({ watchKey: currentRoute })

    const navigationLinks = [
        {
            label: 'Dashboard',
            to: '/admin/administration/dashboard',
        },
        {
            label: 'Departments',
            to: '/admin/administration/departments',
        },
        {
            label: 'Designations',
            to: '/admin/administration/designations',
        },
        {
            label: 'Classes',
            to: '/admin/administration/classes',
        },
        {
            label: 'Student Housing',
            to: '/admin/administration/housing/houses',
        },
        {
            label: 'Exeats',
            to: '/admin/administration/exeats',
        },
        {
            label: 'Academic sessions',
            to: '/admin/administration/academic-sessions',
        },
        {
            label: 'Examinations',
            to: '/admin/administration/examinations',
        },
        {
            label: 'Admissions/Openings',
            to: '/admin/administration/admissions',
        },
        {
            label: 'Applications',
            to: '/admin/administration/applications',
        },
        {
            label: 'Documents',
            to: '/admin/administration/documents',
        },
        {
            label: 'Downloadables',
            to: '/admin/administration/downloadables',
        },
        {
            label: 'Scholarships',
            to: '/admin/administration/scholarships',
        },
    ]

    return (
        <div>
            <div className='w-full'>
                {(canScrollLeft || canScrollRight) && (
                    <div className='mb-2 flex items-center justify-end gap-2'>
                        <button
                            type='button'
                            onClick={() => {scrollByDirection(-1)}}
                            disabled={!canScrollLeft}
                            className='flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 text-gray-600 transition duration-200 hover:border-vcm-purple hover:text-vcm-purple disabled:cursor-not-allowed disabled:opacity-40'
                            aria-label='Scroll administration links left'
                        >
                            <ChevronIcon className='h-4 w-4' />
                        </button>

                        <button
                            type='button'
                            onClick={() => {scrollByDirection(1)}}
                            disabled={!canScrollRight}
                            className='flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 text-gray-600 transition duration-200 hover:border-vcm-purple hover:text-vcm-purple disabled:cursor-not-allowed disabled:opacity-40'
                            aria-label='Scroll administration links right'
                        >
                            <ChevronIcon className='h-4 w-4 rotate-180' />
                        </button>
                    </div>
                )}

                <div ref={scrollContainerRef} className='scrollbar-hidden w-full overflow-x-auto'>
                    <div className='flex min-w-max items-center'>
                        {navigationLinks.map((navigationLink) => {
                            const isActive = currentRoute.includes(navigationLink.to)

                            return (
                                <NavLink
                                    key={navigationLink.to}
                                    to={navigationLink.to}
                                    data-active={isActive}
                                    className={`nav-button shrink-0 whitespace-nowrap px-3 py-3 text-sm font-medium ${isActive ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}
                                >
                                    {navigationLink.label}
                                </NavLink>
                            )
                        })}
                    </div>
                </div>
            </div>
            <div className={`mt-10 min-h-screen`}>
                <main>{children}</main>
            </div>
        </div>
    )
}

export default AdministrationLayout